module.exports = __webpack_public_path__ + "img/Speaker=Matt Zhao.b2a90aae.png";